<template>
  <div id="app">
    <PC
      v-if="!isPhone"
      :iOSUrl="iOSUrl"
      :androidUrl="androidUrl"
      :androidSize="androidSize"
      :html5Url="html5Url"
    />
    <Mobile
      v-if="isPhone"
      :iOSUrl="iOSUrl"
      :androidUrl="androidUrl"
      :androidSize="androidSize"
    />
  </div>
</template>

<script>
import PC from "./components/PC.vue";
import Mobile from "./components/Mobile.vue";
import axios from "axios";

export default {
  name: "app",
  components: {
    PC,
    Mobile,
  },
  data() {
    return {
      isPhone: false,
      androidUrl:
        "https://oss.zt2zs.ztgame.com/ztweb/com.ztgame.zth5_1.0.48.apk",
      androidSize: null,
      iOSUrl:
        "itms-services://?action=download-manifest&url=https://oss.zt2zs.ztgame.com/ztweb/ztweb_ios.plist",
      // iOS: "itms-services://?action=download-manifest&url=https://oss.zt2zs.ztgame.com/ztweb/ztweb_ios.plist"
      html5Url: "https://zth5.ztgame.com/ztweb",
    };
  },
  mounted() {
    var self = this;
    window.onresize = () => {
      return setTimeout(() => {
        self.refreshEnv();
      }, 300);
    };
    self.refreshEnv();

    axios({
      method: "head",
      url: this.androidUrl,
    }).then((res) => {
      if (res.headers["content-length"]) {
        self.androidSize = self.renderSize(res.headers["content-length"]);
      }
    });

    axios({
      method: "head",
      url: this.androidPreviewUrl,
    }).then((/* res*/) => {
      // self.androidPreviewSize = self.renderSize(res.headers["content-length"]);
    });
  },
  methods: {
    refreshEnv() {
      if (
        navigator.userAgent.match(
          /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
        )
      ) {
        this.isPhone = true;
      } else {
        this.isPhone = false;
      }
    },
    renderSize(value) {
      if (null == value || value == "") {
        return "0 Bytes";
      }

      var unitArr = new Array(
        "Bytes",
        "KB",
        "MB",
        "GB",
        "TB",
        "PB",
        "EB",
        "ZB",
        "YB"
      );
      var index = 0,
        srcsize = parseInt(value);
      index = Math.floor(Math.log(srcsize) / Math.log(1024));
      var size = srcsize / Math.pow(1024, index);
      //  保留的小数位数
      size = size.toFixed(2);
      return size + unitArr[index];
    },
  },
};
</script>

<style>
#app {
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #333333;
}

body {
  margin: 0px;
}
</style>
